import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CasePageWrapper',
  setup(__props) {

const favorited = ref<Array<string>>([]);
const isFavorited = (id: string) => {
  return favorited.value.find((x) => x == id);
};
const onFavoriteClick = (id: string) => {
  const val = favorited.value.find((x) => x == id);
  if (val) {
    favorited.value = favorited.value.filter((x) => x != id);
  } else {
    favorited.value.push(id);
  }
};

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    isFavorited: isFavorited,
    onFavoriteClick: onFavoriteClick,
    favorited: favorited.value
  })
}
}

})